var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 41,
    viewBox: "0 0 37 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_30131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6722 36.1031C24.2765 36.1031 24.856 36.4037 25.2833 36.9388C25.7106 37.4739 25.9506 38.1996 25.9506 38.9564C25.9506 39.7131 25.7106 40.4389 25.2833 40.974C24.856 41.5091 24.2765 41.8097 23.6722 41.8097C23.0679 41.8097 22.4884 41.5091 22.0611 40.974C21.6338 40.4389 21.3938 39.7131 21.3938 38.9564C21.3938 38.1996 21.6338 37.4739 22.0611 36.9388C22.4884 36.4037 23.0679 36.1031 23.6722 36.1031ZM23.6722 22.7876C24.2765 22.7876 24.856 23.0882 25.2833 23.6233C25.7106 24.1584 25.9506 24.8842 25.9506 25.6409C25.9506 26.3977 25.7106 27.1234 25.2833 27.6585C24.856 28.1936 24.2765 28.4942 23.6722 28.4942C23.0679 28.4942 22.4884 28.1936 22.0611 27.6585C21.6338 27.1234 21.3938 26.3977 21.3938 25.6409C21.3938 24.8842 21.6338 24.1584 22.0611 23.6233C22.4884 23.0882 23.0679 22.7876 23.6722 22.7876ZM23.6722 9.47217C24.2765 9.47217 24.856 9.77278 25.2833 10.3079C25.7106 10.843 25.9506 11.5687 25.9506 12.3255C25.9506 13.0822 25.7106 13.808 25.2833 14.3431C24.856 14.8782 24.2765 15.1788 23.6722 15.1788C23.0679 15.1788 22.4884 14.8782 22.0611 14.3431C21.6338 13.808 21.3938 13.0822 21.3938 12.3255C21.3938 11.5687 21.6338 10.843 22.0611 10.3079C22.4884 9.77278 23.0679 9.47217 23.6722 9.47217Z",
    fill: "#29AEE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_30131"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.128906,
    y: 0.00292969,
    width: 36.4547,
    height: 40.7832,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingMenu);
export default __webpack_public_path__ + "static/media/booking_menu.7d39ac7c.svg";
export { ForwardRef as ReactComponent };